module.exports = __webpack_public_path__ + "static/B-Present-4cc48a3dd2cf292049d2ed24f38df2c2.jpg";